import PersonalStatistics from './PersonalStatistics';
import { Avatar, Box, Button, IconButton, Stack, Typography } from "@mui/joy";
import { useContext, useState } from "react";
import { LayoutContext } from "../../context";

import { APIGetEvents } from "../../api";
import Cookies from "js-cookie";
import CalendarBlock from "../Manager/CalendarBlock";
import ListDealBlock from "./ListDealBlock";





export default function DraftsmanPage(){
    const { account, setAccount, setListEvents, setLock, setModalEvent } = useContext(LayoutContext);

    const [statsRevision, setStatsRevision] = useState(0);

    // useEffect(() => {
    //     if (account?.rate_access?.find(item => item.service == 'unit_economy') == -1)
    //         navigate("/lk");
    // }, []);

    const handleDateClick = () => {
      setModalEvent({ event: null, open: true });
    };

    // Подгружаем события
    // function updateListEvents() {
    //   APIGetEvents().then((data) => {
    //       if (data?.length) {
    //           console.log("Events", data);
    //           setListEvents(data);
    //       }
    //   })
    // }

    function handlerExitClick () {
      Cookies.remove("auth_token"); // Удаляем токен из cookies
      setLock(true);
      setAccount({});
    }

    return (
      <Box
        sx={{
          px: { xs: 2, md: 6 },
          mt: {
              xs: 2,
              md: 3,
          },
          pb: { xs: 2, sm: 2, md: 3 },
        }}
      >
        <Box
            sx={{
                display: 'flex',
                // mb: 2,
                gap: 1,
                flexDirection: { xs: 'column', sm: 'row' },
                alignItems: { xs: 'start', sm: 'center' },
                flexWrap: 'wrap',
                justifyContent: 'space-between',
            }}
        >
            <Stack direction={'row'} sx={{ width: '100%', justifyContent: 'space-between' }}>
              <Typography level="h1" component="h1">
                  Сделки
              </Typography>
            </Stack>
        </Box>
        
        <Box sx={{ my: 3 }}>
            <PersonalStatistics refreshKey={statsRevision} />
            <ListDealBlock onChanged={() => setStatsRevision(value => value + 1)} />
        </Box>
      </Box>
  );
}